export default __webpack_public_path__ + "static/media/security.801b8848.jpg";